import DispatchConstants from 'app/shared/constants/DispatchConstants';
import LoadingConstants from 'app/shared/constants/LoadingConstants';

const initState = () => ({
    unrecognizedUsers: [],
    loadingState: LoadingConstants.INITIAL,
    error: null,
});

const unrecognizedUsers = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.USER_MANAGEMENT_GET_UNRECOGNIZED_USERS_SUCCESS:
            return {
                ...state,
                loadingState: LoadingConstants.SUCCESS,
                unrecognizedUsers: payload.unrecognizedUsers,
            };
        case DispatchConstants.USER_MANAGEMENT_SET_UNRECOGNIZED_USERS_LOADING_STATE:
            return {
                ...state,
                loadingState: payload,
            };
        case DispatchConstants.USER_MANAGEMENT_UNRECOGNIZED_USERS_INIT:
            return initState();
        default:
            return state;
    }
};

export default unrecognizedUsers;
